export default "__VITE_PUBLIC_ASSET__3e90f1ed__"